import React from 'react'

export const DevLog = () => {
    return <div id="devlog" style={{ backgroundColor: "lightyellow", color: "#000" }}>DEVLOG<br /></div>
}